import axiosInstance from "../service/api_service.js";
import ApiRoutes from "../utils/api_routes.js";

export const getAllAssignedProjects = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.assignedProjects, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAllMyProjects = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.myProjects, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addReport = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addReport, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getReport = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getReport, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const applyLeave = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.applyLeave, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getMyLeaves = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getLeave, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getTasks = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getTasks, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
export const getPendingTasks = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getPendingTasks, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const updateTaskStatus = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateTaskStatus, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addProject = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addProject, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addModuleByEmployee = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addModule, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
